import { BaseApiRequest } from '@api/BaseApi';
import { getOffset } from '@api/helpers';

export const getSavedTimePeriod = () => {
  return BaseApiRequest(null, `/SavedTimePeriod/Get`, 'gpr', 'POST', {});
};

export const createSavedTimePeriod = (data) => {
  return BaseApiRequest(null, `/SavedTimePeriod/Create`, 'gpr', 'POST', {
    ...data,
    userTimezone: getOffset(data.startDate)
  });
};

export const updateSavedTimePeriod = (data) => {
  return BaseApiRequest(null, `/SavedTimePeriod/Update`, 'gpr', 'PUT', {
    ...data,
    userTimezone: getOffset(data.startDate)
  });
};

export const deleteSavedTimePeriod = (id) => {
  return BaseApiRequest(null, `/SavedTimePeriod/Delete`, 'gpr', 'DELETE', { id });
};
